export default __webpack_public_path__ + "static/media/matlab.3d4e15a6.svg";